import { getBrowsePath } from '@sainsburys-tech/boltui-utils'
import { BrowseHelper } from './BrowseHelper'
import config from '../config'

export default class HeadHelper {
  static getLinkTags(canonicalUrl, productStoreState, categoryStoreState) {
    const linkTags = [
      { rel: 'canonical', href: canonicalUrl },
      { rel: 'icon shortcut', href: '/favicon.ico' }
    ]

    const paginationLinkTags = this.getPaginationLinkTagsForPLP(productStoreState, categoryStoreState)

    if (paginationLinkTags.length) {
      linkTags.push.apply(linkTags, paginationLinkTags)
    }

    return linkTags
  }

  static getPaginationLinkTagsForPLP(productStoreState, categoryStoreState) {
    const linkTags = []
    const isPLP = categoryStoreState.isPlp || categoryStoreState.isPlpPlus

    if (!isPLP) return linkTags

    if (productStoreState.currentPage > 1) {
      linkTags.push({
        rel: 'prev',
        href: this.previousPLPLink(productStoreState, categoryStoreState)
      })
    }

    if (productStoreState.currentPage < productStoreState.meta.totalPages) {
      linkTags.push({
        rel: 'next',
        href: this.nextPLPLink(productStoreState, categoryStoreState)
      })
    }

    return linkTags
  }

  static previousPLPLink(productStoreState, categoryStoreState) {
    return this.getPLPLink(productStoreState, categoryStoreState, productStoreState.currentPage - 1)
  }

  static nextPLPLink(productStoreState, categoryStoreState) {
    return this.getPLPLink(productStoreState, categoryStoreState, productStoreState.currentPage + 1)
  }

  static getPLPLink(productStoreState, categoryStoreState, pageNumber) {
    const params = {
      currentCatName: categoryStoreState.categoryName,
      ancestors: categoryStoreState.ancestors,
      currentCatId: categoryStoreState.categoryId,
      filterUriFragments: productStoreState.appliedFilterUriFragments.allFilters,
      sortBy: productStoreState.appliedSortBy,
      pageNumber
    }

    const browsePath = getBrowsePath(BrowseHelper.buildCorrectUrlBrowseParams(params))

    return `${config.home}${browsePath}`
  }
}
